import DeleteWorkspaceController from 'components/app/controllers/DeleteWorkspaceController';
import React from 'react';

export default function DeleteWorkspace(): JSX.Element {
  return <DeleteWorkspaceController />;
}
